/**
 * Signing out, as a capability the shell can ask for.
 *
 * The component that owns the realm session supplies the capability, and
 * everything downstream consumes a plain context whose default is "no way
 * to sign out". Nothing can throw, and the fallback is a disabled menu item
 * rather than a blank page.
 */
import { createContext, useContext, type ReactNode } from 'react';

type SignOut = () => Promise<void>;

const SignOutContext = createContext<SignOut | null>(null);

export function SignOutProvider({
  signOut,
  children,
}: {
  signOut: SignOut;
  children: ReactNode;
}) {
  return <SignOutContext.Provider value={signOut}>{children}</SignOutContext.Provider>;
}

/** `null` when nothing upstream can sign the operator out. */
export function useSignOut(): SignOut | null {
  return useContext(SignOutContext);
}
